import { BaseAmountTable } from '../../libs/amount_table'

class ElementAmountTable extends BaseAmountTable {
  constructor() {
    super('.element_amount', true)
  }
}

export default () => {
  new ElementAmountTable()
}
